<template>
  <div class="init-config-course-step wizard-step">
    <div class="wizard-step-body">
      <!-- 客数 + 開始時間（左右 50/50 等分・各カラム中央寄せ） -->
      <section class="wizard-section-card">
        <div class="init-grid">
          <div class="init-col">
            <div class="text-subtitle-2 text--secondary mb-2">
              客数
            </div>
            <div class="d-flex align-center justify-center customer-counter">
              <v-btn
                fab
                color="error"
                large
                :disabled="customerCount <= 0"
                @click="handleCountChange(customerCount - 1)"
              >
                <v-icon>
                  {{ icons.mdiMinus }}
                </v-icon>
              </v-btn>

              <div class="counter-value mx-4 d-flex align-center">
                <v-icon class="mr-2">
                  {{ icons.mdiAccountOutline }}
                </v-icon>
                <span class="text-h4 font-weight-bold">{{ customerCount || 0 }}</span>
                <span class="ml-1 text-subtitle-1">名</span>
              </div>

              <v-btn
                fab
                color="primary"
                large
                @click="handleCountChange(customerCount + 1)"
              >
                <v-icon>
                  {{ icons.mdiPlus }}
                </v-icon>
              </v-btn>
            </div>
          </div>

          <div class="init-col-divider" />

          <div class="init-col">
            <div class="text-subtitle-2 text--secondary mb-2">
              セット開始時間
            </div>
            <div class="d-flex justify-center">
              <time-drum-picker
                :value="startAt"
                @input="handleStartAtChange"
              />
            </div>
          </div>
        </div>
      </section>

      <!-- コース選択（カード内スクロール）-->
      <section
        v-if="customerCount > 0"
        class="wizard-section-card wizard-section-card--fill"
      >
        <div class="wizard-section-scroll pa-3">
          <v-row dense>
            <v-col
              v-for="course in courses"
              :key="course.id"
              cols="12"
              sm="6"
              md="4"
            >
              <init-config-course-card
                :course="course"
                :selected="course.id === selectedCourseId"
                @select="handleSelect"
              />
            </v-col>
          </v-row>
        </div>
      </section>

      <!-- 税サ選択（コース選択後） -->
      <section
        v-if="selectedCourseId"
        class="wizard-section-card"
      >
        <div class="wizard-section-body">
          <tax-charge-selector
            :value="taxCharge"
            @input="handleTaxChargeChange"
          />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mdiPlus, mdiMinus, mdiAccountOutline } from '@mdi/js'
import InitConfigCourseCard from '../parts/InitConfigCourseCard.vue'
import TaxChargeSelector from '../parts/TaxChargeSelector.vue'
import TimeDrumPicker from '@/views/components/time/TimeDrumPicker.vue'

export default {
  name: 'InitConfigCourseStep',
  components: { InitConfigCourseCard, TaxChargeSelector, TimeDrumPicker },
  props: {
    courses: { type: Array, required: true },
    selectedCourseId: { type: [Number, String], default: null },
    customerCount: { type: Number, default: 0 },
    taxCharge: { type: String, default: 'normal' },
    startAt: { type: Date, default: null },
  },
  emits: ['update:selectedCourseId', 'update:customerCount', 'update:taxCharge', 'update:startAt'],
  setup(_, { emit }) {
    const handleSelect = course => {
      emit('update:selectedCourseId', course.id)
    }

    const handleCountChange = next => {
      emit('update:customerCount', Math.max(0, Number(next) || 0))
    }

    const handleTaxChargeChange = v => {
      emit('update:taxCharge', v || 'normal')
    }

    const handleStartAtChange = d => {
      emit('update:startAt', d)
    }

    return {
      handleSelect,
      handleCountChange,
      handleTaxChargeChange,
      handleStartAtChange,
      icons: { mdiPlus, mdiMinus, mdiAccountOutline },
    }
  },
}
</script>

<style scoped>
.init-grid {
  display: flex;
  align-items: stretch;
  padding: 12px 16px;
}
.init-col {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 0;
}
.init-col-divider {
  flex: 0 0 1px;
  background: rgba(127, 127, 127, 0.18);
  margin: 0 12px;
}
</style>
